import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { PairBoostersBadge } from '@root/entities/pair/ui'
import { PairTicker } from '@root/entities/pair/ui/common'
import { premiumFontCss } from '@root/entities/premium/ui'

import type { PairActivity } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  activity: PairActivity.PremiumActivity
} & ClassNameProps

export const PremiumFeedTableCurrencyCell: React.FC<Props> = ({ activity }) => {
  const pair = activity.pair
  const premiumInfo = pair?.premiumInfo

  return (
    <Root>
      <CurrencyIcon
        currency={activity.currency}
        size={22}
        withNetwork
        withGoogleLens={false}
        pairAddress={pair?.address}
      />
      {pair ? (
        <PairTickerStyled pair={pair} />
      ) : (
        <Ticker ellipsis>{activity.currency.ticker}</Ticker>
      )}
      {premiumInfo ? (
        <PairBoostersBadge
          currency={activity.currency}
          premiumInfo={premiumInfo}
        />
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;
`

const Ticker = styled(Typography)`
  ${premiumFontCss}

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
const PairTickerStyled = styled(PairTicker)`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
